module.exports = "/images/vendor/flag-icon-css/flags/1x1/ye.svg?d13e1629bdb0f80baef6f33d88503231";